module.exports = {"id":"194781","name":"Renan Ribeiro","rating":"73","photo":"./data/images/photos/4/194781.png","club":{"name":"Estoril Praia","logo":"./data/images/clubs/EstorilPraia.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RenanRibeiro0.json
// module id = 3569
// module chunks = 0